import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
// import App from './MobileApp';
import App from './App';

import './lib.r2/utils/Globals';
import Sys from './lib.r2/utils/SystemUtils';
import UI from './lib.r2/ui/ui-controls';
// import Test3D from './Test3D';


const container = document.getElementById('root');
const root = ReactDOM.createRoot(container); 	// createRoot(container!) if you use TypeScript
root.render(<UI.Loading spinner />);

Sys.loadConfig('config.json').then(() => {
	root.render(<App />);
})
